var path = '/pages/picklists/views/base.tpl.html';
var html = "<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'list'\" ui-view=\"list\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'contacts'\" ui-view=\"contacts\"></div>\n<div class=\"height-less-navbar\" ng-show=\"$state.current.data.view == 'editor'\" ui-view=\"editor\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/picklists/views/base.tpl.html
// module id = 2297
// module chunks = 1